import {LogoutLink} from '/src/com/yext/platform/users/js/newloginhelpers/logoutbutton';
import NewLoginTemplate from '/src/com/yext/platform/users/js/newloginhelpers/newlogintemplate';
import {registerComponentForJsonDataWithUIKit} from '/ui/lib/easyuikit';
import {yext} from '/ui/lib/msg';

const {Box, Text, Link} = require('@yext/mana-ui');

/**
 * Component to render the access denied help links page
 */
export function AccessDeniedHelpLinks({username, supportEmail, authenticityToken, whitelabelInfo}) {
  return (
    <NewLoginTemplate
      title={yext.msg('Access Denied')}
      cardContent={
        <CardContent
          username={username}
          supportEmail={supportEmail}
          authenticityToken={authenticityToken}
        />}
      whitelabelInfo={whitelabelInfo}
    />
  );
}

function CardContent({username, supportEmail, authenticityToken}) {
  const userText = username
    ? (<div id="access-denied-help-links">
      <Text fontSize={'sm'}>
        {yext.msg('Your user, {username}, does not have access to the documentation you are requesting.', {username})}
      </Text></div>)
  : (<div id="access-denied-help-links">
    <Text fontSize={'sm'}>
      {yext.msg('Your user does not have access to the documentation you are requesting.')}
    </Text></div>);
  return (
    <Box>
      {userText}
      <br />
      <Text fontSize={'sm'}>
        {yext.msg('If you have a login for a user in a different account that has access to this documentation, please ')}
        <LogoutLink authenticityToken={authenticityToken} />
        {yext.msg(' then log on as that user and go back to the URL you want to view.')}
      </Text>
      <br />
      <Text
        fontSize={'sm'}
        dangerouslySetInnerHTML={{__html: yext.msg('If you need additional assistance, please <a href="mailto:{supportEmail}" >contact support</a>.', {supportEmail})}} />
    </Box>);
}

document.addEventListener('DOMContentLoaded', () => {
  registerComponentForJsonDataWithUIKit('AccessDeniedHelpLinks', AccessDeniedHelpLinks);
});
